// extracted by mini-css-extract-plugin
module.exports = {"ant-layout-sider-trigger":"style_ant-layout-sider-trigger__3Ms1x","dropdown":"style_dropdown__2VQgr","avatar":"style_avatar__1pDkr","menuIcon":"style_menuIcon__32W_H"};